import { render } from "./FadeInfo.vue?vue&type=template&id=61508d3c"
import script from "./FadeInfo.vue?vue&type=script&lang=js"
export * from "./FadeInfo.vue?vue&type=script&lang=js"

import "./FadeInfo.vue?vue&type=style&index=0&id=61508d3c&lang=scss"
script.render = render

export default script